import React, { useEffect, useRef, useState } from "react";
import { View, Image, TouchableOpacity, Platform } from "react-native";
import Button from "components/Partials/Buttons";
import smile from "components/assets/grey_smile.png";

const isMobile = Platform.OS !== "web";

const ProfileEditImage = ({
  imageUrl,
  editable,
  onImageChange,
  size = 80,
}) => {
  const fileInputRef = useRef();
  const [isHovering, setIsHovering] = useState(false);

  const finalImage = imageUrl || smile;

  useEffect(() => {
    setIsHovering(false);
  }, [imageUrl]);

  const handleImageClick = () => {
    if (!editable) return;

    setIsHovering(false);

    if (Platform.OS === "web") {
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
        fileInputRef.current.click();
      }
    } else {
      if (window?.main?.lib?.pickImage) {
        window.main.lib.pickImage()
          .then(result => {
            if (result && !result.cancelled) {
              const nextImage = result.uri || result.file || result.blob;
              const localPreviewUrl = result.uri || null;
              
              setIsHovering(false);
              onImageChange && onImageChange(nextImage, localPreviewUrl);
            }
          })
          .catch(() =>
            window.main.lib.setStatusState("Image selection failed")
          );
      }
    }
  };

  const handleFileChange = (e) => {
    setIsHovering(false);
    
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();

      reader.onloadend = () => {
        const localPreviewUrl = reader.result;
        setIsHovering(false);
        onImageChange && onImageChange(file, localPreviewUrl);
      };

      reader.readAsDataURL(file);
    }
  };

  const hoverProps = Platform.OS === "web"
    ? {
        onMouseEnter: () => setIsHovering(true),
        onMouseLeave: () => setIsHovering(false),
      }
    : {};

  return (
    <View
      style={{
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        marginBottom: 20,
        width: size + 10,
        height: size + 10,
      }}
      {...hoverProps}
    >
      <TouchableOpacity
        activeOpacity={0.8}
        onPress={handleImageClick}
        style={{
          width: size,
          height: size,
          borderRadius: size / 2,
          overflow: "hidden",
        }}
      >
        <Image
          source={
            typeof finalImage === "string"
              ? { uri: finalImage }
              : finalImage
          }
          style={{
            width: size,
            height: size,
            borderRadius: size / 2,
            backgroundColor: "#eee",
            borderWidth: 1,
            borderColor: "#eee",
            objectFit: "cover",
          }}
          resizeMode="cover"
          accessibilityLabel="Profile Image"
        />

        {(editable && (isHovering || isMobile)) && (
          <Button
            type="secondary"
            ficon="camera"
            size="icon"
            style={{
              position: "absolute",
              top: 4,
              // top: 25,
              right: 4,
              // right: 20,
              zIndex: 20,
              width: 0,
              height: 0,
              padding: 0,
              borderRadius: 0,
              borderWidth: 0,
              backgroundColor: "#fff",
              elevation: 1,
            }}
            iconSize={18} //Little camera in upper right of picture top 4 right 4
            // iconSize={50} //Big camera in middlie of picture top 25 right 20
            text=""
            onPress={handleImageClick}
          />
        )}
      </TouchableOpacity>

      {Platform.OS === "web" && editable && (
        <input
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          ref={fileInputRef}
          onChange={handleFileChange}
        />
      )}
    </View>
  );
};

export default ProfileEditImage;